<template>

	<div class="scrolldown">
        <span class="scrolldown_icon">
            <font-awesome-icon :icon="['far', 'angle-down']"/>
        </span>
	</div>

</template>

<script>

export default {
	name: "Scrolldown",
	components: {},
	props: []
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;
@use '@/assets/scss/partials/animations' as *;

.scrolldown {
	bottom: 5rem;
	color: #000000;
	cursor: pointer;
	left: 50%;
	position: fixed;
	z-index: $z_header;

	&_icon {
		animation: bounce 1.5s ease-in-out infinite alternate;
		font-size: 2.4rem;
		position: absolute;
		@include transition();
		transform: translateY(0);

		svg {
			color: $black;
			filter: drop-shadow(0px 2px 7px $white);
		}
	}
}

.lightTheme {
	.scrolldown {
		&_icon {
			svg {
				color: $white;
				filter: drop-shadow(0px 2px 7px $black);
			}
		}
	}
}
</style>